import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-push-notification-preview-dialog-box",
  templateUrl: "./push-notification-preview-dialog-box.component.html",
  styleUrls: ["./push-notification-preview-dialog-box.component.css"],
})
export class PushNotificationPreviewDialogBoxComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<PushNotificationPreviewDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  selectedLanguageType = "DEFAULT";
  languageTypeList = [
    {
      displayName: "Default",
      value: "DEFAULT",
    },
    {
      displayName: "Alias",
      value: "ALIAS",
    },
  ];

  ngOnInit(): void {}

  checkWhetherAlias() {
    return (
      this.data?.aliasCountryCode &&
      this.data?.aliasCountryCode?.length > 0 &&
      this.selectedLanguageType === "ALIAS"
    );
  }

  setLanguageType(type) {
    this.selectedLanguageType = type.value;
  }

  cancel(){
    this.dialogRef.close(false);
  }
}
